import { render, staticRenderFns } from "./BorcluTakbisPicker.vue?vue&type=template&id=0370ccc2"
import script from "./BorcluTakbisPicker.vue?vue&type=script&lang=ts"
export * from "./BorcluTakbisPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports